// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientListTeamCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ClientListTeamCountQuery = { __typename?: 'Query', teams: { __typename?: 'TeamConnection', totalCount: number } };

export const Operations = {
  Query: {
    ClientListTeamCount: 'ClientListTeamCount' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ClientListTeamCountDocument = gql`
    query ClientListTeamCount {
  teams {
    totalCount
  }
}
    `;

/**
 * __useClientListTeamCountQuery__
 *
 * To run a query within a React component, call `useClientListTeamCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientListTeamCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientListTeamCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientListTeamCountQuery(baseOptions?: Apollo.QueryHookOptions<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>(ClientListTeamCountDocument, withFetchPolicyContext(options));
      }
export function useClientListTeamCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>(ClientListTeamCountDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientListTeamCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>(ClientListTeamCountDocument, withFetchPolicyContext(options));
        }
export type ClientListTeamCountQueryHookResult = ReturnType<typeof useClientListTeamCountQuery>;
export type ClientListTeamCountLazyQueryHookResult = ReturnType<typeof useClientListTeamCountLazyQuery>;
export type ClientListTeamCountSuspenseQueryHookResult = ReturnType<typeof useClientListTeamCountSuspenseQuery>;
export type ClientListTeamCountQueryResult = Apollo.QueryResult<ClientListTeamCountQuery, ClientListTeamCountQueryVariables>;